export const seedCatalog = {
  redRambo: { name: "Red Rambo radish organic", trayRate: 24.5, purchaseStatus: "Buy now" },
  chinaRose: { name: "China Rose radish organic", trayRate: 24.5, purchaseStatus: "Buy now" },
  broccoli: { name: "Broccoli Waltham 29 organic", trayRate: 13, purchaseStatus: "Buy now" },
  redAcre: { name: "Red Acre cabbage microgreens", trayRate: 10.5, purchaseStatus: "Buy now" },
  purpleKohlrabi: { name: "Purple Vienna kohlrabi microgreens", trayRate: 9.5, purchaseStatus: "Buy now" },
  tatsoi: { name: "Tatsoi microgreens", trayRate: 7.5, purchaseStatus: "Buy now" },
  wasabi: { name: "Wasabi mustard organic", trayRate: 9.5, purchaseStatus: "Buy now" },
  arugula: { name: "Arugula organic", trayRate: 10, purchaseStatus: "Buy now" },
  amaranth: { name: "Garnet red amaranth organic", trayRate: 7.5, purchaseStatus: "Future/test" },
};

export const sheetSizes = {
  small: {
    name: "Small",
    seededArea: 70.6858,
    dryPaperMass: 11.857,
    processWaterMl: 950,
    note: "Small oval validation refill",
  },
  medium: {
    name: "Medium",
    seededArea: 88.3573,
    dryPaperMass: 14.8212,
    processWaterMl: 1200,
    note: "Default centerpiece validation refill",
  },
  large: {
    name: "Large",
    seededArea: 243.2771,
    dryPaperMass: 40.8077,
    processWaterMl: 3300,
    note: "Premium validation refill; use a larger forming setup",
  },
};

export const paperModes = {
  control: {
    name: "Control",
    kelpPercent: 0,
    note: "No fertilizer or powder. Use this for outsourced baseline batches.",
  },
  kelp025: {
    name: "0.25% kelp test",
    kelpPercent: 0.25,
    note: "A/B validation only. Replace base pulp with kelp by dry weight.",
  },
  kelp050: {
    name: "0.5% kelp test",
    kelpPercent: 0.5,
    note: "A/B validation only. Do not release until pH, EC, mold, and germination pass.",
  },
};

export const blendRecipes = [
  {
    id: "glow-purple-core",
    name: "Glow Purple Core",
    availability: "Current buy",
    color: "Purple, blue-green, and deep green",
    flavor: "Mild brassica with moderate radish bite",
    harvest: "7-12 days",
    sizePolicy: "Small or medium first; large only after the medium run passes",
    ingredients: [
      ["redRambo", 28],
      ["redAcre", 24],
      ["broccoli", 20],
      ["purpleKohlrabi", 18],
      ["tatsoi", 10],
    ],
  },
  {
    id: "rose-immunity-snap",
    name: "Rose Immunity Snap",
    availability: "Current buy",
    color: "Rose-pink stems over layered greens",
    flavor: "Clean green with a light mustard finish",
    harvest: "6-11 days",
    sizePolicy: "Small or medium",
    ingredients: [
      ["chinaRose", 32],
      ["broccoli", 28],
      ["tatsoi", 20],
      ["wasabi", 12],
      ["redAcre", 8],
    ],
  },
  {
    id: "daily-calm-greens",
    name: "Daily Calm Greens",
    availability: "Current buy",
    color: "Deep and soft greens with purple stem flecks",
    flavor: "Mild, tender, and lightly peppery",
    harvest: "8-13 days",
    sizePolicy: "Small or medium",
    ingredients: [
      ["tatsoi", 30],
      ["broccoli", 25],
      ["redAcre", 20],
      ["purpleKohlrabi", 15],
      ["arugula", 10],
    ],
  },
  {
    id: "spicy-night-market",
    name: "Spicy Night Market",
    availability: "Current buy",
    color: "Purple and pink stems through bright greens",
    flavor: "Bold radish, mustard, and arugula pepper",
    harvest: "6-10 days",
    sizePolicy: "Small at 75% standard dose; medium at full dose",
    doseMultiplier: { small: 0.75 },
    ingredients: [
      ["redRambo", 24],
      ["chinaRose", 24],
      ["wasabi", 18],
      ["arugula", 18],
      ["redAcre", 16],
    ],
  },
  {
    id: "rainbow-without-amaranth",
    name: "Rainbow Without Amaranth",
    availability: "Current buy",
    color: "Purple, pink, blue-green, and deep-green bands",
    flavor: "Balanced mild-to-peppery",
    harvest: "7-12 days",
    sizePolicy: "Medium first; large after zoned seeding passes",
    ingredients: [
      ["redRambo", 18],
      ["chinaRose", 18],
      ["broccoli", 16],
      ["redAcre", 16],
      ["purpleKohlrabi", 14],
      ["tatsoi", 10],
      ["arugula", 8],
    ],
  },
  {
    id: "mild-pink-brunch",
    name: "Mild Pink Brunch",
    availability: "Current buy",
    color: "Pink stems, velvet green, and light purple flecks",
    flavor: "Gentle radish, mild greens, and a small pepper note",
    harvest: "7-12 days",
    sizePolicy: "Small or medium",
    ingredients: [
      ["chinaRose", 25],
      ["tatsoi", 25],
      ["broccoli", 20],
      ["purpleKohlrabi", 20],
      ["arugula", 10],
    ],
  },
  {
    id: "purple-pepper-salad",
    name: "Purple Pepper Salad",
    availability: "Current buy",
    color: "Purple stems and a blue-green canopy",
    flavor: "Peppery but less mustard-hot",
    harvest: "7-12 days",
    sizePolicy: "Small or medium",
    ingredients: [
      ["redRambo", 24],
      ["purpleKohlrabi", 22],
      ["redAcre", 22],
      ["arugula", 20],
      ["broccoli", 12],
    ],
  },
  {
    id: "green-evidence-anchor",
    name: "Green Evidence Anchor",
    availability: "Current buy",
    color: "Dense green with small purple accents",
    flavor: "Mostly mild with a clean, low-heat finish",
    harvest: "7-13 days",
    sizePolicy: "Small or medium",
    ingredients: [
      ["broccoli", 35],
      ["redAcre", 25],
      ["tatsoi", 20],
      ["purpleKohlrabi", 12],
      ["wasabi", 8],
    ],
  },
  {
    id: "citrus-heat-accent",
    name: "Citrus Heat Accent",
    availability: "Current buy",
    color: "Pink-green contrast with a tidy canopy",
    flavor: "Crisp radish with a mustard edge",
    harvest: "6-11 days",
    sizePolicy: "Small or medium",
    ingredients: [
      ["chinaRose", 30],
      ["wasabi", 18],
      ["broccoli", 22],
      ["redAcre", 15],
      ["tatsoi", 15],
    ],
  },
  {
    id: "beauty-expansion-test",
    name: "Beauty Expansion Test",
    availability: "Future/test seed required",
    color: "Purple and blue-green with fuchsia speckles",
    flavor: "Mild to peppery and visually premium",
    harvest: "8-14 days",
    sizePolicy: "Medium only until amaranth synchrony passes",
    ingredients: [
      ["redRambo", 24],
      ["redAcre", 22],
      ["broccoli", 18],
      ["purpleKohlrabi", 16],
      ["tatsoi", 12],
      ["amaranth", 5],
      ["arugula", 3],
    ],
  },
];

export function calculateBatch({ blend, size, sheets, paperMode }) {
  const sheet = sheetSizes[size];
  const paper = paperModes[paperMode];
  const count = Math.max(1, Number(sheets) || 1);
  const doseMultiplier = blend.doseMultiplier?.[size] || 1;
  const weightedTrayRate = blend.ingredients.reduce(
    (sum, [seedId, percent]) => sum + seedCatalog[seedId].trayRate * (percent / 100),
    0,
  );
  const seedPerSheet = (sheet.seededArea / 200) * weightedTrayRate * doseMultiplier;
  const totalSeed = seedPerSheet * count;
  const seedIngredients = blend.ingredients.map(([seedId, percent]) => ({
    id: seedId,
    ...seedCatalog[seedId],
    percent,
    grams: totalSeed * (percent / 100),
  }));
  const totalPaper = sheet.dryPaperMass * count;
  const kelpFraction = paper.kelpPercent / 100;

  return {
    count,
    sheet,
    paper,
    doseMultiplier,
    weightedTrayRate,
    seedPerSheet,
    totalSeed,
    seedIngredients,
    totalPaper,
    paperIngredients: [
      { id: "base", name: "Abaca/cellulose/cotton base pulp", percent: 91.5 - paper.kelpPercent, grams: totalPaper * (0.915 - kelpFraction) },
      { id: "hemp", name: "Hemp/coco microfiber", percent: 6.5, grams: totalPaper * 0.065 },
      { id: "seedPulp", name: "Seed-paper moisture pulp", percent: 2, grams: totalPaper * 0.02 },
      ...(paper.kelpPercent > 0
        ? [{ id: "kelp", name: "Soluble kelp powder", percent: paper.kelpPercent, grams: totalPaper * kelpFraction }]
        : []),
    ],
    processWaterMl: sheet.processWaterMl * count,
  };
}

export function buildProcessSteps({ blend, batch }) {
  const seedLine = batch.seedIngredients.map((item) => `${item.name}: ${item.grams.toFixed(2)} g`).join("; ");
  const paperLine = batch.paperIngredients.map((item) => `${item.name}: ${item.grams.toFixed(2)} g`).join("; ");
  const perSheetSeed = batch.seedPerSheet.toFixed(2);
  const quadrants = (batch.totalSeed / 4).toFixed(2);
  const minimumHarvestDay = Number(blend.harvest.match(/\d+/)?.[0] || 7);

  return [
    {
      id: "intake",
      phase: "Prepare",
      title: "Open the batch record and inspect inputs",
      durationSeconds: 5 * 60,
      instructions: [
        "Enter the operator name, batch ID, seed lot IDs, pulp lot ID, and date before opening ingredients.",
        "Reject wet, musty, damaged, treated, dyed, or unlabeled seed. Photograph any rejected input.",
        `Confirm the recipe is ${blend.name}, ${batch.sheet.name}, ${batch.count} sheet(s), ${batch.paper.name}.`,
      ],
      gate: "All lots are identified and every input package is clean, dry, and within its use date.",
    },
    {
      id: "sanitize",
      phase: "Prepare",
      title: "Wash hands and sanitize the work area",
      durationSeconds: 10 * 60,
      instructions: [
        "Wash hands, put on clean gloves, and keep sick workers away from seed and paper handling.",
        "Clean and sanitize the scale pan, bowls, blender jar, mold, screens, couch sheets, press surfaces, drying rack, trays, and packaging table.",
        "Use potable water. Let food-contact sanitizer reach its labeled contact time, then allow surfaces to drain and dry as directed by the label.",
      ],
      gate: "No visible residue, standing sanitizer, soil, food, or dirty tools remain in the clean zone.",
    },
    {
      id: "weigh-paper",
      phase: "Make paper",
      title: "Weigh the dry paper components",
      durationSeconds: 8 * 60,
      instructions: [
        `Tare a clean dry bowl. Weigh: ${paperLine}.`,
        `Measure ${Math.round(batch.processWaterMl)} mL potable process water as the standardized starting volume for this batch.`,
        "Keep each component separate until its step. Record actual weights to 0.01 g; target tolerance is +/-2% per paper component.",
      ],
      gate: `The dry paper total is ${batch.totalPaper.toFixed(2)} g +/-2%, and the selected paper mode is recorded.`,
    },
    {
      id: "hydrate",
      phase: "Make paper",
      title: "Hydrate the pulp",
      durationSeconds: 15 * 60,
      instructions: [
        "Place the base pulp and seed-paper moisture pulp in the sanitized blender vessel.",
        "Add approximately one-third of the measured process water. Submerge all fiber and start the timer.",
        "Do not add seeds. Do not add hemp/coco reinforcement yet. Do not add held additives such as biochar, calcium carbonate, methylcellulose, or humic powder.",
      ],
      gate: "Pulp is fully wet with no dry fiber core.",
    },
    {
      id: "blend-pulp",
      phase: "Make paper",
      title: "Blend pulp only",
      durationSeconds: 45,
      instructions: [
        "Blend the hydrated base pulp at medium speed for 45 seconds.",
        batch.paper.kelpPercent > 0
          ? `Add ${batch.paperIngredients.find((item) => item.id === "kelp")?.grams.toFixed(2)} g kelp during the final 10 seconds. This is an A/B test batch.`
          : "This is a control batch. Add no fertilizer or powder.",
        "Stop immediately if the blender heats noticeably. Never blend seeds.",
      ],
      gate: "Slurry is even with no large pulp clumps and no seed has contacted the blender.",
    },
    {
      id: "disperse-fiber",
      phase: "Make paper",
      title: "Disperse reinforcement and prepare the mold",
      durationSeconds: 2 * 60,
      instructions: [
        `Stir ${batch.paperIngredients.find((item) => item.id === "hemp")?.grams.toFixed(2)} g hemp/coco microfiber into the slurry by hand for 2 minutes.`,
        "Add the remaining measured water and mix until fiber distribution looks uniform.",
        "Wet the clean forming screen and place it level in the mold or marked forming station.",
      ],
      gate: "No reinforcement clumps are larger than a pea and the screen is level.",
    },
    {
      id: "weigh-seed",
      phase: "Add seed",
      title: "Weigh and mix the seed blend",
      durationSeconds: 8 * 60,
      instructions: [
        `Tare a separate dry seed bowl. Weigh exactly: ${seedLine}.`,
        `Total seed target is ${batch.totalSeed.toFixed(2)} g, or ${perSheetSeed} g per sheet. Seed-weight tolerance is +/-0.02 g per ingredient and +/-0.05 g total.`,
        "Fold the seed blend gently with a clean spoon for 30 turns. Do not crush, soak, rinse, or blend these small seeds.",
      ],
      gate: "Every seed weight is recorded and the total agrees with the calculator within tolerance.",
    },
    {
      id: "form-sheet",
      phase: "Add seed",
      title: "Form each wet sheet",
      durationSeconds: Math.max(4 * 60, batch.count * 4 * 60),
      instructions: [
        `Divide the slurry into ${batch.count} equal portion(s), one portion per ${batch.sheet.name.toLowerCase()} sheet. Keep the slurry moving gently between sheets so fibers do not settle.`,
        "Pour one portion into the level mold. Drain until the fiber layer holds together but remains visibly wet.",
        `Target dry mass is ${batch.sheet.dryPaperMass.toFixed(2)} g per sheet. Keep thickness even at the edges and corners.`,
      ],
      gate: "Each wet sheet has even coverage with no holes, thick ridges, or exposed screen areas.",
    },
    {
      id: "apply-seed",
      phase: "Add seed",
      title: "Apply seeds by proportion and zone",
      durationSeconds: Math.max(2 * 60, batch.count * 2 * 60),
      instructions: [
        `Divide the full seed blend into ${batch.count} equal sheet portions of ${perSheetSeed} g each.`,
        `For each sheet, visually divide the seeded area into four equal quadrants. Apply one-quarter of that sheet's seed portion to each quadrant; the full-batch quadrant reference is ${quadrants} g across all sheets.`,
        "Tap the seed cup close to the wet surface, working left-to-right and then top-to-bottom. Use a clean dry pick to separate visible clumps.",
        "Lay a very thin veil of retained pulp over the seeds only where needed for retention. Seeds should remain near the surface, not buried.",
      ],
      gate: "No bald area is larger than a thumbprint, no seed pile is more than two seeds deep, and colored seeds are distributed as intended.",
    },
    {
      id: "press",
      phase: "Dry",
      title: "Press and remove water immediately",
      durationSeconds: Math.max(3 * 60, batch.count * 3 * 60),
      instructions: [
        "Cover the wet sheet with a clean couch sheet and press evenly from center to edge.",
        "Remove free water without crushing seed. Do not wring, iron, microwave, or expose the sheet to high heat.",
        "Transfer each sheet to a labeled clean mesh drying rack. Record the press-complete time.",
      ],
      gate: "Sheet lifts as one piece, seeds remain attached, and no puddled water remains.",
    },
    {
      id: "dry",
      phase: "Dry",
      title: "Dry low and fast with moving air",
      durationSeconds: 12 * 60 * 60,
      instructions: [
        "Dry in a clean, shaded area with continuous gentle airflow at normal room temperature. Do not use direct sun or high heat.",
        "Keep sheets separated and flat. Do not stack. Check at 2 hours for curled edges, wet pockets, odor, or premature seed swelling.",
        "At 12 hours, weigh and record each sheet. Continue drying if any cool/damp area remains.",
      ],
      gate: "No musty odor, visible mold, swollen seed, trapped wet zone, or fiber transfer to the rack.",
    },
    {
      id: "stable-weight",
      phase: "QC",
      title: "Confirm stable dry weight",
      durationSeconds: 12 * 60 * 60,
      instructions: [
        "Record each sheet weight, wait 12 hours in the same dry conditions, then weigh again.",
        "A sheet is dry only when the second weight differs by no more than 1% from the first dry reading.",
        `Compare each sheet with the ${batch.sheet.dryPaperMass.toFixed(2)} g paper target plus ${perSheetSeed} g seed target. Record variance; do not trim data to make it pass.`,
      ],
      gate: "Weight is stable within 1%; no odor, visible growth, condensation, or flexible wet core is present.",
    },
    {
      id: "qc",
      phase: "QC",
      title: "Run release QC and retain a grow-out sample",
      durationSeconds: 10 * 60,
      instructions: [
        "Inspect seed retention, evenness, cracks, edge strength, color, odor, and batch label. Photograph both sides of one representative sheet.",
        "Wet one retained sample in a known volume of source water. Record wet-out time, pH, and EC beside a source-water control; hold any surprising shift for review.",
        "Place one retained sample in HydroTerrace. It should wet evenly within 1-3 minutes without shedding enough fiber to threaten the reservoir or pump.",
      ],
      gate: "No mold, off-odor, major bald zones, loose seed loss, cracking, clogging, or unexplained pH/EC result.",
    },
    {
      id: "package",
      phase: "Finish",
      title: "Package, label, and quarantine",
      durationSeconds: Math.max(6 * 60, batch.count * 60),
      instructions: [
        "Package only stable, fully dry sheets in clean dry pouches with one food-safe desiccant packet.",
        "Label blend, size, batch ID, manufacture date, seed lots, paper lot, operator, and control/kelp mode.",
        "Keep the batch in HOLD status until the retained grow-out passes. Store cool, dark, and dry.",
      ],
      gate: "Every pouch is sealed, traceable, dry, and physically separated from released inventory.",
    },
    {
      id: "blackout",
      phase: "Grow demo",
      title: "Run the retained-sample germination check",
      durationSeconds: 36 * 60 * 60,
      instructions: [
        "Place the retained sheet in HydroTerrace using the customer watering method. Keep the sheet moist but not saturated.",
        "Cover for the initial germination period and maintain approximately 70-75 F with gentle airflow nearby.",
        "At 36 hours, photograph emergence, odor, mold, dry zones, floating seeds, and paper behavior.",
      ],
      gate: "Emergence is broadly even and there is no visible mold, off-odor, or failed wetting zone.",
    },
    {
      id: "grow-light",
      phase: "Grow demo",
      title: "Move the retained sample to light",
      durationSeconds: 16 * 60 * 60,
      instructions: [
        "Remove the cover and begin a 16-hour light / 8-hour dark daily cycle.",
        "Use bottom watering or the normal HydroTerrace reservoir method. Keep the paper moist, never waterlogged, and maintain airflow.",
        `Continue daily observations through the ${blend.harvest} target. The first formal evaluation is day ${minimumHarvestDay}.`,
      ],
      gate: "Seedlings stand upright, roots anchor through the paper, and the batch has no mold or unacceptable odor.",
    },
    {
      id: "release",
      phase: "Finish",
      title: "Score the grow-out and release or reject",
      durationSeconds: 15 * 60,
      instructions: [
        "Compare germination with a loose-seed-on-hemp-mat control made from the same lots.",
        "Pass only if paper germination reaches at least 85% of the loose-mat control, the canopy is harvestable by the recipe window, and taste/appearance are acceptable.",
        "Record the decision as RELEASE, REWORK, or REJECT with the reason. Do not release a failed or undocumented batch.",
      ],
      gate: "A named reviewer signed the batch decision and all photos, weights, pH/EC readings, and grow-out observations are attached.",
    },
  ];
}
